import { Component, OnInit } from '@angular/core';
import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';
import { chatMessage } from '../../../../@core/interfaces/patient-services/message';
import { EzoChatAppService } from './../service/ezo-chat-app.service';
 
@Component({
  selector: 'ngx-ezo-chat-app',
  templateUrl: './ezo-chat-app.component.html',
  styleUrls: ['./ezo-chat-app.component.scss']
})
export class EzoChatAppComponent implements OnInit {

  tenantId = localStorage.getItem("tenantId");
  branchId = localStorage.getItem("branchId");
  userId =parseInt(localStorage.getItem("userId"));
  phyID= localStorage.getItem("physicianId"); 
  userName = localStorage.getItem("userName");

  msgCount:number=0;
  typedMessage: string = '';
  messagesList: any[]=[];
  message = new chatMessage();
  data:any;
  usersList:any=[];
  flipped:boolean=false;
  isopenChat:boolean=false;
  selectedUser;
  constructor(public chatService:EzoChatAppService) { }

  ngOnInit(): void {  
  } 

  
  openChatDialog(){
    this.chatService.getOnlineUsersInv();
    this.isopenChat=true;
  }
  closeChatDialog(){
    this.isopenChat=false;
    this.flipped=false;
  }
  chatUser(data){
    this.flipped=true;
    this.selectedUser=data;
    this.selectedUser.messageList.push(...data.messageList);
    console.log("click User", data);
  }
  ngAfterViewInit(): void {
    this.startConenction();
    this.getOnlineUser();
    this.receiveMessage();
  }
  startConenction(){
    this.chatService.startConnection();
  }
  receiveMessage(){
    this.chatService.receiveMsg.subscribe(recdata=>{
      let data={...JSON.parse(recdata)} as chatMessage;
      console.log("receiveMsg", data);
      data.reply=false;
      data.type = "receive"; 
      console.log(data); 
      var recData=this.usersList.find(x=>{ return x.connectionid==data.senderId})
      recData.messageList.push({...data});
      this.openChatDialog();
      this.chatUser(recData);
    })
  }
  getOnlineUser(){
    this.chatService.usersList.subscribe(onlineUsers=> {
        // console.log("onlineUsers",onlineUsers);
        this.usersList=[];
        onlineUsers.filter(data=>{
            this.usersList.push({
              name:data.userId.toString(),
              userId:data.userId.toString(),
              title:"0",
              connectionid:data.signalrId,
              messageList:[]
            });
        });
        // console.log("UserList",this.usersList)
    });
  }
  
  sendMessage(event: any, userName: string, avatar: string, reply: boolean) {
    console.log(event, userName, avatar, reply)
    this.message.clientuniqueid=this.selectedUser.connectionid;
    this.message.date=new Date();
    this.message.tenantId=this.tenantId;
    this.message.branchId=this.branchId;
    this.message.text=event.message;
    this.message.files=event.files;
    this.message.chatType=event.files?.length>0?'file':'text';
    this.message.type = "sent"; 
    this.message.receiverId=this.selectedUser?.userId;
    this.message.senderId=this.chatService.getConnectionId();
    this.message.userName=this.userName;
    this.message.reply=true;
    this.message.avatar=''; 
    this.selectedUser.messageList.push({...this.message});
    this.chatService.sendMessage(this.selectedUser.connectionid,this.message)
  }
  toggleView() { this.flipped = !this.flipped; }
 

  disconnectConenction(){
    this.chatService.endConnection();
  }
  ngOnDestroy(): void { 
    this.disconnectConenction();
  }
}
